<template>
	<div class="position-relative">
		<div class="authentication-wrapper authentication-basic container-p-y p-4 p-sm-0">
			<div class="authentication-inner py-6">
				<!-- Register Card -->
				<div class="card p-md-7 p-1">
					<!-- Logo -->
					<div class="app-brand justify-content-center mt-5">
						<a href="index.html" class="app-brand-link gap-2">
							<span class="app-brand-logo demo">
								<span style="color: var(--bs-primary)">
									<img src="@/assets/logo.png" style=" width: 160px;">
								</span>
							</span>
						</a>
					</div>
					<!-- /Logo -->
					<div class="card-body mt-1">
						<p class="mb-5 text-center" v-if="!resetToken">Vous avez oublié votre mot de passe ?</p>
						<p class="mb-5 text-center" v-if="resetToken">Modifier votre mot de passe</p>

						<form id="formAuthentication" @submit.prevent="forgotPassword" class="mb-5" v-if="!resetToken">
							<div class="form-floating form-floating-outline mb-5">
								<input type="text" class="form-control" id="email" name="email" placeholder="Votre email" v-model="form.email" @input="clearError('email')" />
								<label for="email">Email</label>
								<small v-if="errors.email" class="text-danger">{{ errors.email }}</small>
							</div>
							
							<button class="btn btn-primary d-grid w-100" type="submit">Demander un nouveau mot de passe</button>
						</form>

						<form id="formAuthentication" @submit.prevent="updateNewPassword" class="mb-5" v-else>
							<div class="form-floating form-floating-outline mb-5">
								<input type="password" class="form-control" id="password" name="password" placeholder="Mot de passe" v-model="formReset.password" @input="clearError('password')" />
								<label for="password">Nouveau mot de passe</label>
								<small v-if="errors.password" class="text-danger">{{ errors.password }}</small>
							</div>

							<div class="form-floating form-floating-outline mb-5">
								<input type="password" class="form-control" id="password2" name="password2" placeholder="Mot de passe" v-model="formReset.password2" @input="clearError('password2')" />
								<label for="password2">Répéter nouveau mot de passe</label>
								<small v-if="errors.password2" class="text-danger">{{ errors.password2 }}</small>
							</div>
							
							<button class="btn btn-primary d-grid w-100" type="submit">Mettre à jour votre mot de passe</button>
						</form>

						<p class="text-center">
							<router-link to="/login">
								<span>Retour</span>
							</router-link>
						</p>
					</div>
				</div>
				<!-- Register Card -->
				<img
					alt="mask"
					src="@/assets/img/illustrations/auth-basic-register-mask-light.png"
					class="authentication-image d-none d-lg-block"
					data-app-light-img="illustrations/auth-basic-register-mask-light.png"
					data-app-dark-img="illustrations/auth-basic-register-mask-dark.png" />
			</div>
		</div>
	</div>
</template>

<script>
import "@/assets/vendor/css/pages/page-auth.css";

import HTTP from "@/axios";

export default {
	name: "LoginPage",

	data() {
		return {
			resetToken: null,
			form: {
				email: ""
			},
			formReset: {
				password: "",
				password2: ""
			},
			errors: {},
		};
	},

	async mounted() {
		this.resetToken = this.$route.query.token;
	},

	methods: {
		clearError(field) {
			// Supprime l'erreur pour le champ spécifié
			if (this.errors[field]) {
				delete this.errors[field];
			}
		},

		validateForm() {
			this.errors = {};

			if (!this.form.email || !this.validateEmail(this.form.email)) {
				this.errors.email = "Veuillez entrer une adresse e-mail valide.";
			}
			return Object.keys(this.errors).length === 0;
		},

		validateFormReset() {
			this.errors = {};

			if (!this.formReset.password) {
				this.errors.password = "Veuillez entrer un mot de passe valide.";
			}

			if (!this.formReset.password2) {
				this.errors.password = "Veuillez entrer un mot de passe valide.";
			}

			if (this.formReset.password !== this.formReset.password2) {
				this.errors.password = "Les mots de passe ne correspondent pas";
			}
			
			return Object.keys(this.errors).length === 0;
		},

		validateEmail(email) {
			const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			return re.test(email);
		},

		async forgotPassword() {
			const validated = this.validateForm();

			if (!validated)
				return;

			try {
				await HTTP.post('/auth/forgot-password', this.form);

				// Alert user
				alert(`Un email de réinitialisation à été envoyé sur: ${this.form.email}`);

				this.$router.push({ path: '/login' });
			} catch (error) {
				alert("Impossible de trouver ce compte.");
			}
		},

		async updateNewPassword() {
			const validated = this.validateFormReset();

			if (!validated)
				return;

			try {
				const response = await HTTP.post('/auth/set-new-password', {
					resetPasswordToken: this.resetToken,
					password: this.formReset.password
				});

				// Alert user
				alert("Votre mot de passe à été modifié avec succès.");

				this.$router.push({
					path: '/login',
					query: { email: response.data.email }
				});
			} catch (error) {
				alert("Impossible de changer le mot de passe, merci de contacter contact@pika-aero.com");
			}
		}
	}
};
</script>
